import React from 'react'
import { hostProfileDefault } from 'constants/host'
import ImageWithDefault from './ImageWithDefault'

const HostProfileImage = props => <ImageWithDefault {...props} defaultSrc={hostProfileDefault} />

export default HostProfileImage
